import DistanceUnits from "./DistanceUnits";

export function inCurrentDistanceUnits(newVal: number|null, du: string) {
    if(newVal === null) {
        return null
    }

    const distanceUnitData = DistanceUnits.find(d => d.value === du)
    if(!distanceUnitData) {
        console.error('Failed to resolve distance unit ', du)
        return `${newVal.toFixed(0)}m`
    }
    const inUnits = newVal / distanceUnitData.metres;
    return `${inUnits.toFixed(1)}`
}